/* eslint-disable @typescript-eslint/no-non-null-assertion */
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Container } from 'reactstrap';
import List from './List';
import { makeSearchCategoriesSelector } from '~redux/menu/selectors';
import AlgoliaHeader from '~view/widgets/AlgoliaHeader';
import { Filters } from '~view/widgets/AlgoliaHeader/ListFilters';
import ProductSearchProvider from '~view/widgets/ProductSearchProvider';

export type ProductListProps = {
  category: string;
  subCategory?: string;
};

const ProductList: React.FC<ProductListProps> = ({ category, subCategory }) => {
  const selectCategories = useMemo(
    () => makeSearchCategoriesSelector(category),
    [category]
  );
  const searchCategories = useSelector(selectCategories);
  const categories = useMemo(
    () => searchCategories?.map((category) => category.name),
    [JSON.stringify(searchCategories)]
  );
  const listId = useMemo(
    () => `products > ${category}${subCategory ? ` > ${subCategory}` : ''}`,
    [category, subCategory]
  );

  return (
    <Container>
      <ProductSearchProvider
        itemsPerPage={40}
        category={category}
        subCategory={subCategory}
        listId={listId}
        refinementAttributes={Object.entries(Filters)
          .filter(([_, values]) => !values.items)
          .map(([attribute]) => attribute)}
        personalize
      >
        <AlgoliaHeader listId={listId} />
        <List categories={categories} listId={listId} />
      </ProductSearchProvider>
    </Container>
  );
};

export default ProductList;
